import $ from "cash-dom";

export default (function () {
    $(document).ready(function () {
        var log = typeof debug !== "undefined";
        if (log) console.log("%cfunction_cover.js initialized", "color: green;");

        var selector = ".cover:not(img, video)";

        function cover() {
            $(selector).each(function () {
                var instance = $(this);
                var parent = $(this).parent();
                var instanceRatio = instance[0].clientWidth / instance[0].clientHeight;
                var parentRatio = parent[0].clientWidth / parent[0].clientHeight;

                parent.addClass("flex center-content");

                if (instanceRatio <= parentRatio) {
                    instance[0].style.width = "100%";
                    instance[0].style.height = "auto";
                } else {
                    instance[0].style.width = "auto";
                    instance[0].style.height = "100%";
                }
            });
        }

        cover();
        $(window).on("resizeEnd fetchSuccess", cover);
    });
})();
